import styled from 'styled-components';
import CustomBlockButton from '../../../components/button/CustomBlockButton';

export const ListMode = {
    Container: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 100px;
    `,
    CountBox: styled.div`
        display: flex;
        gap: 10px;
        &>div{
            flex:1;
            border: 1px solid #e0e0e0;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 600;
        }
    `,
    ProductName: styled.div`
    `,
    ItemBox: styled.div`
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        cursor: pointer;

        &.selected{
            background: #0000ff20;
        }

        .flexBox{
            display: flex;
            justify-content: space-between;
            gap: 10px;
            align-items: center;

            .selectButton{
                width: 40px;
                background: #efefef;
                color: #000;
                border: none;
                font-size: 12px;
            }
        }

        .productName{
            display: flex;
            font-weight: 700;
            font-size: 12px;
            justify-content: space-between;

            & > .ctns{
                font-weight: 900;
                color:green;
            }
        }
        .detailInfo{
            font-weight: 500;
            font-size: 8px;

        }
    `,
    FooterBox: styled.div`
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        gap: 10px;
        padding: 10px;

        button{
            background: #efefef;
            color: #000;
            font-weight: 700;
            border: none;
            height: 60px;
            font-size: 18px;
        }
    `,
}

export const ResultMode = {
    Container: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding-bottom: 100px;
        height: auto;
        background: #fff;
    `,
    WaybillNumber: styled.div`
        padding:10px;
        background: #efefef;
        font-weight: 700;
        font-size: 14px;
        border-radius: 5px;
        position: sticky;
        top:0;
        cursor: pointer;
        z-index: 10;

        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
    `,
    CountBox: styled.div`
        display: flex;
        gap: 10px;
        &>div{
            flex:1;
            border: 1px solid #e0e0e0;
            padding: 10px;
            border-radius: 5px;
            font-size: 14px;
            font-weight: 600;
        }
    `,
    EventButtonBox: styled.div`
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 20px;
        margin-bottom: 20px;
        button{
            width: 80px;
            color: #000;
            border: none;
            background: #efefef;
            font-size: 14px;
        }

        .countBox{
            font-size: 12px;
            font-weight: 700;
            cursor: pointer;
        }
    `,
    ItemBox: styled.div`
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        .productName{
            display: flex;
            font-weight: 700;
            font-size: 12px;
            justify-content: space-between;

            & > .ctns{
                font-weight: 900;
                color:green;
            }
        }
        .detailInfo{
            font-weight: 500;
            font-size: 8px;

        }
        &.isSelected{
            background: #0000ff20;
        }
    `,
    FooterBox: styled.div`
        position: fixed;
        bottom: 0;
        left: 0;
        width: 100%;
        display: flex;
        gap: 10px;
        padding: 10px;

        button{
            color: #000;
            border: none;
            background: #efefef;
            &.refresh{
                color: #000;
                border: 1px solid #efefef;
                background: #fff;
            }
        }
    `,
}

export const ScanMode = {
    Container: styled.div`
        background: #fff;
    `,
    FormField: styled.div`
        display: flex;
        flex-direction: column;
        gap: 10px;
        padding: 20px;

        .modeButtonBox{
            display: flex;
            gap: 10px;

            button{
                width: 80px;

                &.active{
                    background: #000;
                    color: #fff;
                }
            }
        }
    `,

}

export const DeleteButtonField = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 20px;
        button{
            width: 100px;
            margin-left:auto;
            background: var(--redColor1);
            color: #fff;
            border: none;
        }
    `,
}

export const StageSelection = {
    Container: styled.div`
        padding: 0 10px;
        margin-top: 20px;
    `,
    SelectionButton: styled(CustomBlockButton)`
        width: auto;
        height: auto;
        min-height: 40px;
        padding: 5px 10px;
        background-color: #efefef;
        color: #000;
        border: none;
        border-radius: 5px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: background-color 0.3s;

        &:hover {
            background-color: #e0e0e0;
        }
    `,
    DialogHeader: styled.div`
        padding: 10px;
    `,
    StageList: styled.div`
        padding: 10px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    `,
    StageItem: styled.div`
        padding: 10px;
        border: 1px solid #e0e0e0;
        border-radius: 5px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;
        display: flex;
        flex-direction: column;
        gap: 10px;

        &:hover{
            background: #efefef;
        }

        .uuid{
            font-weight: 600;
        }

        .createdAt{
            font-size: 10px;
            color: #888;
            display: flex;
            justify-content:flex-end;
        }
    `,
}